export default (height) => height
  .substring(0, 4)
  .replace(/[^\d]/g, '')
  .replace(/(\d{1})/, '$1.')
  .replace(/^(\d{1})\.(\d{2})/, '$1.$2');
